import { getAuth } from "firebase/auth";
import { API_BASE_URL } from "./apiBase";
const base = API_BASE_URL;
export const paperKey = (uid, kind) => `studyden:paper:${uid}:${kind}`;
export const paperQuestionMarkText = result =>
  typeof result?.markAwarded === "number" && Number.isFinite(result.markAwarded)
    ? `${result.markAwarded}/${result.maxMark ?? ""}` : "Pending review";
export const paperQuestionStatus = result => result?.markingState || result?.status || "unresolved";
export const csvCell = value => {
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  let text = String(value ?? "");
  const trimmed = text.replace(/^\s+/, "");
  if (/^[=+@-]/.test(trimmed) || Array.from(trimmed).some((char, index) => index === 0 && char.charCodeAt(0) < 32)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};
export const paperSummaryText = summary => summary?.provisional
  ? `${summary.knownAwarded ?? 0} known marks · ${summary.unresolvedCount} unresolved · provisional`
  : `${summary?.totalAwarded ?? "—"}/${summary?.totalPossible ?? "—"}`;
export async function paperRequest(path, body, token) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["X-Paper-Upload-Token"] = token;
  else {
    const user = getAuth().currentUser;
    if (!user) throw new Error("Sign in to access your paper submissions.");
    headers.Authorization = `Bearer ${await user.getIdToken()}`;
  }
  const response = await fetch(`${base}${path}`, { method: body === undefined ? "GET" : "POST", headers,
    body: body === undefined ? undefined : JSON.stringify(body), cache: "no-store" });
  const data = await response.json();
  if (!response.ok) throw Object.assign(new Error(data.error || "The paper request failed."), { status: response.status });
  return data;
}
// A rejection the server will repeat for the same payload. Auth, timeout, rate-limit,
// server and network failures stay retryable so a lost acceptance can be replayed idempotently.
export const isDefinitivePaperRejection = error =>
  Number.isInteger(error?.status) && error.status >= 400 && error.status < 500 && ![401, 408, 429].includes(error.status);
export async function paperDownload(batchId, submissionId) {
  const data = await paperRequest(`/api/paper-report/${batchId}/${submissionId}`);
  return fetch(data.url);
}
export function pollingDeadline(current, batchId, now, duration = 60000) {
  return current?.batchId === batchId ? current : { batchId, expiresAt: now + duration };
}
